import { contactFactory } from '@trukt/factories/contactFactory';
import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../../../../mocks';

export const accountContactServiceHandlers = [
  http.get(mockTruktTmsApiUrl('/account/:accountGuid/contacts/search'), ({ request }) => {
    const url = new URL(request.url);

    const search = url.searchParams.get('search');

    if (!search) {
      return HttpResponse.json({
        results: contactFactory.buildList(3),
      });
    }

    return HttpResponse.json({
      results: contactFactory.buildList(3, { name: search }),
    });
  }),
];
